import type { SVGProps } from 'react';
import React from 'react';

export enum IconTypes {
  'apple' = 'apple',
  'google' = 'google',
  'google_v1' = 'google_v1',
  'facebook' = 'facebook',
  'facebook_v1' = 'facebook_v1',
  'googlePlay' = 'googlePlay',
  'email' = 'email',
  'crop' = 'crop',
  'expandLess' = 'expandLess',
  'expandMore' = 'expandMore',
  'resize' = 'resize',
  'upload' = 'upload',
  'arrowBack' = 'arrowBack',
  'checked' = 'checked',
  'close' = 'close',
  'content' = 'content',
  'errorOutline' = 'errorOutline',
  'burger' = 'burger',
  'eye' = 'eye',
  'eyeClosed' = 'eyeClosed',
  'question' = 'question',
  'logout' = 'logout',
  'twitter' = 'twitter',
  'instagram' = 'instagram',
  'linkedin' = 'linkedin',
  'x' = 'x',
  'facebook_rounded' = 'facebook_rounded',
  'instagram_rounded' = 'instagram_rounded',
  'linkedin_rounded' = 'linkedin_rounded',
  'science' = 'science',
  'heart' = 'heart',
  'book' = 'book',
  'pro' = 'pro',
  'arrowRight' = 'arrowRight',
  'settings' = 'settings',
  'bigArrowUp' = 'bigArrowUp',
  'checkCircleOutline' = 'checkCircleOutline',
  'huaweiAppGallery' = 'huaweiAppGallery',
  'galaxyStore' = 'galaxyStore',
  'appleMusic' = 'appleMusic',
  'spotify' = 'spotify',
  'profile-card-stars' = 'profile-card-stars',
  'profile-card-infinity' = 'profile-card-infinity',
  'profile-card-star' = 'profile-card-star',
  'help' = 'help'
}

export interface IIconProps extends Omit<SVGProps<SVGSVGElement>, 'style'> {
  icon: IconTypes;
  size?: 16 | 24 | number;
  width?: number;
  height?: number;
  color?: string;
}

export const Icon: React.FC<IIconProps> = props => {
  const { icon, size = 24, color = 'white', ...restProps } = props;

  return (
    <svg
      width={size}
      height={size}
      style={{ color: `var(--${color})` }}
      {...restProps}
    >
      <use xlinkHref={`#${icon}`} />
    </svg>
  );
};

export default Icon;
